import { render, staticRenderFns } from "./PanelProductPrice.vue?vue&type=template&id=ee96c548&scoped=true"
import script from "./PanelProductPrice.vue?vue&type=script&lang=js"
export * from "./PanelProductPrice.vue?vue&type=script&lang=js"
import style0 from "./PanelProductPrice.vue?vue&type=style&index=0&id=ee96c548&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee96c548",
  null
  
)

export default component.exports